import { KpiCard, SparklineWidget } from "@modootoday/ui-widgets/widgets";
import { useKpis, useSparklines } from "./hooks";

const KPI_CONFIG = [
  { key: "totalKeywords", label: "총 키워드" },
  { key: "totalChannels", label: "총 채널" },
  { key: "totalContents", label: "총 콘텐츠" },
  { key: "activeKeywords", label: "활성 키워드" },
] as const;

export function KpiCards() {
  const { data: kpis, isLoading } = useKpis();
  const { data: sparklines } = useSparklines();

  return (
    <div className="mb-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {KPI_CONFIG.map((config, index) => {
        const value = kpis?.[config.key];
        const spark = sparklines?.[index];
        return (
          <KpiCard
            key={config.key}
            label={config.label}
            value={typeof value === "number" ? value : 0}
            format="compact"
            loading={isLoading}
            sparkline={
              spark && spark.length >= 2 ? (
                <SparklineWidget data={spark} tone="brand" />
              ) : undefined
            }
          />
        );
      })}
    </div>
  );
}
